/*----------------------------------
- CATALOG (SSOT)
----------------------------------*/

export const CLIENT_LOGOS = [
    'Huawei',
    'Acrelec',
    'ATOL',
    'Clone',
    'Hyperplan',
    'MG',
    'Honor',
    'Hisense',
    'Revibe',
    'Techmind',
    'Proya',
    'Mass',
    'Darbyon',
    'FoodFlow',
] as const;
